import { createSlice } from '@reduxjs/toolkit';

export interface AnalyticReducerState {
  [path: string]: {
    waitForTiles: [];
    tileStatus: Record<string, object>;
    ready: boolean;
  };
}

export const initialAnalyticsState: AnalyticReducerState = {
  '/': {
    waitForTiles: [],
    tileStatus: {},
    ready: false
  }
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: initialAnalyticsState,
  reducers: {
    setTilesToWaitFor: (state, action) => {
      const path = action.payload.path ?? '/';
      state[path] = { waitForTiles: [], tileStatus: {}, ready: false };
      if (action.payload.tiles && action.payload.tiles.length > 0) {
        state[path].waitForTiles = action.payload.tiles;
      } else {
        state[path].ready = true;
      }
    },
    setTileStatus: (state, action) => {
      const path = action.payload.path ?? '/';
      if (!state[path].ready) {
        state[path].tileStatus[action.payload.tileName] = action.payload.page;
        state[path].ready = state[path].waitForTiles.every((tileName) => !!state[path].tileStatus[tileName]);
      }
    },
    reset: (state, action) => {
      const path = action.payload;
      state[path].tileStatus = {};
      state[path].waitForTiles = [];
      state[path].ready = false;
    },
    forceReady: (state, action) => {
      const path = action.payload.path ?? '/';
      if (!state[path].ready) {
        state[path].ready = true;
      }
    }
  }
});

export const { setTilesToWaitFor, setTileStatus, reset, forceReady } = analyticsSlice.actions;
export default analyticsSlice;
